import { render, staticRenderFns } from "./download-btn.vue?vue&type=template&id=ccf19a2a&scoped=true&"
import script from "./download-btn.vue?vue&type=script&lang=ts&"
export * from "./download-btn.vue?vue&type=script&lang=ts&"
import style0 from "./download-btn.vue?vue&type=style&index=0&id=ccf19a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf19a2a",
  null
  
)

export default component.exports